import { z } from 'zod';
export const RESERVED_SLUGS = new Set([
    'admin',
    'api',
    'app',
    'auth',
    'billing',
    'blog',
    'cdn',
    'dashboard',
    'docs',
    'help',
    'login',
    'mail',
    'pilot',
    'signup',
    'status',
    'support',
    'system',
    'www',
]);
/**
 * Canonical slug validation for every stored tenant slug. New slugs are generated by
 * {@link generateTenantSlug}; older tenants still carry hand-typed ones. Constraints: 3–63
 * chars, must start with a letter, end with a letter or number, lowercase alphanumeric +
 * hyphens only, no reserved names.
 */
export const TenantSlugSchema = z
    .string()
    .min(3)
    .max(63)
    .regex(/^[a-z][a-z0-9-]*[a-z0-9]$/, {
    message: 'Slug must start with a letter, end with a letter or number, and contain only lowercase letters, numbers, and hyphens',
})
    .refine((val) => !RESERVED_SLUGS.has(val), {
    message: 'This slug is reserved and cannot be used',
});
//# sourceMappingURL=tenants.js.map